export const ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
}
